import React from 'react';
import { Box } from '@mui/material';

const FullWidthLayout = ({ children }) => (
  <Box sx={{ width: '100%', minHeight: '100vh', p: 2, m: 0 }}>
    {children}
  </Box>
);

export default FullWidthLayout;
